/**
 * Gallery look: one big picture card per video. The clip count sits on the picture, "Quick look",
 * "Full sheet" and "Top 20" show on hover, and the rest is in ⋮. Clicking the card opens the quick look.
 */
import React from "react";
import { VideoData } from "../types";
import { formatDateOnly } from "../../../../utils/dateFormatting";
import { FAILED_TEXT } from "../constants/myLibraryText";
import Pic from "./Pic";
import { CARD } from "./libraryLookText";
import { clock } from "./topClips";
import { VideoCardProps } from "./videoCardProps";

const GalleryView: React.FC<VideoCardProps & { cardWidth: number }> = ({
  videos, onQuickLook, onOpenClips, onTop20, renderMenu, combineMode, picked, onTogglePick, isInFlight, cardWidth,
}) => (
  <div className="grid" style={{ ["--ccl-card" as any]: `${cardWidth}px` }}>
    {videos.map((video: VideoData) => {
      const inFlight = isInFlight(video);
      const failed = video.task_status === "failed";
      const click = () => {
        if (combineMode) onTogglePick(video.id);
        else if (!inFlight && !failed) onQuickLook(video);
      };
      return (
        <div key={video.id} className={`card${picked.has(video.id) ? " picked" : ""}`} onClick={click}>
          <Pic src={inFlight ? null : video.thumbnail} videoUrl={inFlight ? null : video.video}>
            {inFlight ? (
              <span className="badge">{CARD.making}</span>
            ) : !failed && typeof video.clips_count === "number" ? (
              <span className="badge">{CARD.clips(video.clips_count)}</span>
            ) : null}
            {video.duration_in_seconds ? <span className="dur">{clock(video.duration_in_seconds)}</span> : null}
            {combineMode && !inFlight && !failed && (
              <span className="tick">
                <input type="checkbox" readOnly checked={picked.has(video.id)} style={{ accentColor: "#e61d50" }} />
                {picked.has(video.id) ? CARD.inSheet : CARD.addToSheet}
              </span>
            )}
            {!combineMode && !inFlight && !failed && (
              <div className="hov">
                <button type="button" className="pill red" title={CARD.quickLookTitle} onClick={(e) => { e.stopPropagation(); onQuickLook(video); }}>
                  {CARD.quickLook}
                </button>
                <button type="button" className="pill" title={CARD.fullSheetTitle} onClick={(e) => { e.stopPropagation(); onOpenClips(video); }}>
                  {CARD.fullSheet}
                </button>
                <button type="button" className="pill" title={CARD.top20Title} onClick={(e) => { e.stopPropagation(); onTop20(video); }}>
                  {CARD.top20}
                </button>
              </div>
            )}
            {!combineMode && (
              <div className="menu" onClick={(e) => e.stopPropagation()}>{renderMenu(video)}</div>
            )}
          </Pic>
          <div className="body">
            <div className="ttl" title={video.title}>{video.title}</div>
            {inFlight ? (
              <>
                <div className="meta">{CARD.makingNote}</div>
                <div className="prog"><i /></div>
              </>
            ) : (
              <div className="meta">
                {failed ? <span className="bad">{FAILED_TEXT}</span> : formatDateOnly(video.created_at)}
              </div>
            )}
          </div>
        </div>
      );
    })}
  </div>
);

export default GalleryView;
